import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Vacu.Activ.Skopje.Web.Administration';

  constructor(private translate: TranslateService)
  {
    translate.setDefaultLang('mk');
    translate.addLangs(['mk', 'en']);
  }
}
